import i18n from '@/i18n'
import { UserModule } from '@/store/modules/user'
import API from '@/api'
import { Loader } from '@googlemaps/js-api-loader'
import { SappModule } from '@/store/modules/app'
import { mapState, mapActions } from 'vuex'
import moment, { duration } from 'moment-timezone'
export default {
  name: 'vehicleTrajectory',
  data() {
    return {
      pickerOptions: {
        onPick: (date) => {
          this.tempDate = date.minDate
        },
        disabledDate: (time) => {
          if (this.tempDate) {
            const oneWeek = 7 * 24 * 60 * 60 * 1000
            const minTime = this.tempDate.getTime() - oneWeek
            const maxTime = this.tempDate.getTime() + oneWeek
            return time.getTime() <= minTime || time.getTime() >= maxTime
          }
          return false
        }
      },
      form: {
        transTaskNo: '',
        carLicense: '',
        taskStartTimeStamp: '',
        taskEndTimeStamp: '',
        taskTimeStamps: [],
        type: 1
      },
      loading: false,
      loaded: false,
      markerArr: [],
      map: null,
      keywords: '',
      activeIndex: -1,
      modle: 1,
      allPoints: [],
      timer: null,
      pointArr: [],
      flightPath: null,
      mapDrawend: false,
      latlngArr: [],
      formData: {
        status: '',
        taskSiteNo: '',
        transTaskNo: '',
        driverName: '',
        carLicense: '',
        requireCarModelName: '',
        name: this.$t('vehicleTrajectory.index.844698-0'),
        taskSites: [],
        isInstallGPS: false,
        gpsDeviceNo: ''
      }
    }
  },
  computed: {
    ...mapState(['language'])
  },
  watch: {
    '$store.state.sapp.language': {
      immediate: true,
      handler(newValue, oldValue) {
        if (this.loaded) {
          this.loadGoogleMap()
        }
      }
    }
  },
  async mounted() {
    if (this.$route.query.transTaskNo) {
      this.keywords = this.$route.query.transTaskNo
    }
    if (this.keywords) {
      this.form.type = 2
      this.form.transTaskNo = this.keywords
      this.form.carLicense = ''
      this.form.taskStartTimeStamp = ''
      this.form.taskEndTimeStamp = ''
      this.form.taskTimeStamps = []
      // await this.queryDrivingTrack()
      await this.queryTaskSiteList()
    } else {
      this.loadGoogleMap()
    }
    this.loaded = true
  },
  methods: {
    changeType(type) {
      this.form.type = type
      this.form.transTaskNo = ''
      this.form.carLicense = ''
      this.form.taskStartTimeStamp = ''
      this.form.taskEndTimeStamp = ''
      this.form.taskTimeStamps = []
      if (type === 1) {
        this.form.taskTimeStamps = []
      }
      this.formData = {
        status: '',
        taskSiteNo: '',
        transTaskNo: '',
        driverName: '',
        carLicense: '',
        requireCarModelName: '',
        name: this.$t('vehicleTrajectory.index.844698-0'),
        taskSites: [],
        isInstallGPS: false,
        gpsDeviceNo: ''
      }
      this.removeAllMarkers()
    },
    getUTCOffset(timezone) {
      // 创建一个新的 Date 对象
      const date = new Date()

      // 使用 Intl.DateTimeFormat 获取时区偏移量
      const options = { timeZone: timezone, timeZoneName: 'short' }
      const formatter = new Intl.DateTimeFormat([], options)
      const parts = formatter.formatToParts(date)

      // 查找时区偏移部分
      const timeZoneOffset = parts.find(part => part.type === 'timeZoneName').value

      // 解析偏移量
      const match = timeZoneOffset.match(/GMT([+-]\d{1,2}):?(\d{2})?/)

      if (match) {
        const hours = parseInt(match[1], 10)
        const minutes = match[2] ? parseInt(match[2], 10) : 0

        // 格式化偏移量字符串
        const offset = hours + (minutes / 60)
        const sign = offset >= 0 ? '+' : '-'
        const hoursStr = Math.abs(offset).toString().padStart(2, '0')
        const minutesStr = (Math.abs(offset) % 1 * 60).toString().padStart(2, '0')

        // 返回偏移量字符串
        return `UTC${sign}${hoursStr}:${minutesStr}`
      }

      return ''
    },
    calculateHourDifference(timestamp1, timestamp2) {
      const millisecondsPerHour = 1000 * 60 * 60
      const differenceInMilliseconds = Math.abs(timestamp2 - timestamp1)
      const differenceInHours = differenceInMilliseconds / millisecondsPerHour
      return Math.floor(differenceInHours)
    },
    formatTimestamp(timestamp, timeZone) {
      const date = moment.tz(timestamp, timeZone)
      const formattedDate = date.format('YYYY-MM-DD HH:mm:ss')
      return formattedDate
    },
    async queryTaskSiteList() {
      this.loading = true
      try {
        window.actionStart(this.$t('vehicleTrajectory.index.890369-0'))
      } catch (error) {
        console.log(error)
      }
      let params = {}
      if (this.form.type === 2) {
        params = {
          queryType: this.form.type === 1 ? 'GPS' : 'APP',
          transTaskNo: this.form.transTaskNo
        }
      } else {
        if (this.form.transTaskNo) {
          params = {
            queryType: this.form.type === 1 ? 'GPS' : 'APP',
            transTaskNo: this.form.transTaskNo
          }
        } else {
          params = {
            queryType: this.form.type === 1 ? 'GPS' : 'APP',
            transTaskNo: this.form.transTaskNo,
            carLicense: this.form.carLicense,
            taskStartTimeStamp: this.form.taskTimeStamps.length ? this.form.taskTimeStamps[0] : '',
            taskEndTimeStamp: this.form.taskTimeStamps.length ? this.form.taskTimeStamps[1] : ''
          }
        }
      }
      const res = await API.queryTaskSiteList(params)
      this.loading = false
      if (res.code === 0) {
        this.formData = res.data
        if (this.form.type === 2 || this.form.transTaskNo) {
          console.log('carLicensecarLicense', res.data.carLicense, res.data)
          this.form.carLicense = res.data.carLicense
          if (res.data.status === 140) { // 已完成
            this.form.taskTimeStamps = [res.data.taskStartTimeStamp, res.data.taskEndTimeStamp]
          } else if (res.data.status > 60 && res.data.status < 140) { // 进行中
            this.form.taskTimeStamps = [res.data.taskStartTimeStamp, new Date().getTime()]
          } else if (res.data.status === 20 || res.data.status === 40 || res.data.status === 60) { // 未开始
            this.$message({
              type: 'warning',
              /** 上传失败 */
              message: this.$t('vehicleTrajectory.index.890369-1'),
              customClass: 'message-custom-class warning'
            })
            // this.form.taskTimeStamps = []
            // this.form.carLicense = ''
            // this.form.taskStartTimeStamp = ''
            // this.form.taskEndTimeStamp = ''
            // this.form.taskTimeStamps = []
          }
        }
        if (this.formData.taskSites && this.formData.taskSites.length) {
          this.pointArr = []
          this.formData.taskSites.forEach((node, i) => {
            if (node.longitude && node.latitude) {
              this.pointArr.push({
                lat: node.latitude,
                lng: node.longitude
              })
            } else {
              this.pointArr.push({
                lat: '',
                lng: ''
              })
            }
          })
          await this.queryDrivingTrack()
          this.allPoints = [...this.formData.taskSites]
          if (!this.map) {
            this.loadGoogleMap()
          } else {
            // TODO]
            this.addDriver()
            if (this.flightPath) {
              this.flightPath.setMap(null)
              this.flightPath = null
            }
            if (this.latlngArr && this.latlngArr.length) {
              setTimeout(() => {
                this.addDriverLine()
              }, 0)
            }
          }
        } else if (this.form.type === 1) {
          this.pointArr = []
          this.formData.taskSites && this.formData.taskSites.length && this.formData.taskSites.forEach((node, i) => {
            if (node.longitude && node.latitude) {
              this.pointArr.push({
                lat: node.latitude,
                lng: node.longitude
              })
            } else {
              this.pointArr.push({
                lat: '',
                lng: ''
              })
            }
          })
          await this.queryDrivingTrack()
          if (!this.map) {
            this.loadGoogleMap()
          } else {
            // TODO]
            this.addDriver()
            if (this.flightPath) {
              this.flightPath.setMap(null)
              this.flightPath = null
            }
            if (this.latlngArr && this.latlngArr.length) {
              setTimeout(() => {
                this.addDriverLine()
              }, 0)
            }
          }
        } else {
          this.pointArr = []
        }
      } else {
        if (this.form.type === 2) {
          this.form.carLicense = ''
          this.form.taskStartTimeStamp = ''
          this.form.taskEndTimeStamp = ''
          this.form.taskTimeStamps = []
        }
        this.formData = {
          status: '',
          taskSiteNo: '',
          transTaskNo: '',
          driverName: '',
          carLicense: '',
          requireCarModelName: '',
          name: this.$t('vehicleTrajectory.index.844698-0'),
          taskSites: []
        }
        this.$message({
          type: 'error',
          /** 上传失败 */
          message: `${res.msg || this.$t('vehicleTrajectory.index.890369-2')} `,
          customClass: 'message-custom-class error'
        })
      }
      try {
        window.actionEnd(this.$t('vehicleTrajectory.index.890369-0'))
      } catch (error) {
        console.log(error)
      }
    },
    async queryDrivingTrack() {
      console.log('查询轨迹')
      try {
        window.actionStart(this.$t('vehicleTrajectory.index.890369-3'))
      } catch (error) {
        console.log(error)
      }
      let params = {}
      if (this.form.type === 2) {
        params = {
          queryType: this.form.type === 1 ? 'GPS' : 'APP',
          transTaskNo: this.form.transTaskNo
        }
      } else {
        if (this.form.transTaskNo) {
          params = {
            queryType: this.form.type === 1 ? 'GPS' : 'APP',
            transTaskNo: this.form.transTaskNo,
            taskStartTimeStamp: this.form.taskTimeStamps.length ? this.form.taskTimeStamps[0] : '',
            taskEndTimeStamp: this.form.taskTimeStamps.length ? this.form.taskTimeStamps[1] : ''
          }
        } else {
          params = {
            queryType: this.form.type === 1 ? 'GPS' : 'APP',
            transTaskNo: this.form.transTaskNo,
            carLicense: this.form.carLicense,
            taskStartTimeStamp: this.form.taskTimeStamps.length ? this.form.taskTimeStamps[0] : '',
            taskEndTimeStamp: this.form.taskTimeStamps.length ? this.form.taskTimeStamps[1] : ''
          }
        }
      }
      const res = await API.queryDrivingTrack(params)
      if (res.code === 0) {
        this.latlngArr = [...res.data]
      } else {
        this.latlngArr = []
      }
      try {
        window.actionEnd(this.$t('vehicleTrajectory.index.890369-3'))
      } catch (error) {
        console.log(error)
      }
    },
    inputCarLicense() {
      if (this.form.carLicense && (!this.form.taskTimeStamps || !this.form.taskTimeStamps.length)) {
        this.form.taskTimeStamps = [new Date().getTime() - 5 * 3600 * 1000, new Date().getTime()]
      }
      // this.querySearch()
    },
    resetPage() {
      if (this.flightPath) {
        this.flightPath.setMap(null)
        this.flightPath = null
      }
      this.form.taskTimeStamps = []
      this.formData = {
        isInstallGPS: '',
        gpsDeviceNo: '',
        driverName: '',
        followerName: '',
        driverPhone: '',
        followerPhone: '',
        taskSites: [],
        status: '',
        taskSiteNo: '',
        transTaskNo: '',
        carLicense: '',
        requireCarModelName: '',
        name: this.$t('vehicleTrajectory.index.844698-0')
      }
      this.removeAllMarkers()
    },
    clearData() {
      this.form.transTaskNo = ''
      this.form.carLicense = ''
      this.resetPage()
    },
    querySearch(e) {
      console.log(e, this.form.transTaskNo)
      if (!this.form.transTaskNo && !this.form.carLicense) {
        return
      }
      if (this.form.transTaskNo) {
        this.form.transTaskNo = this.form.transTaskNo.trim()
        this.form.carLicense = ''
        this.form.taskTimeStamps = []
      }
      this.form.carLicense = this.form.carLicense.trim()
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(async() => {
        if (this.flightPath) {
          this.flightPath.setMap(null)
          this.flightPath = null
        }
        this.removeAllMarkers()

        await this.queryTaskSiteList()
      }, 300)
    },
    loadGoogleMap() {
      const loader = new Loader({
        apiKey: process.env.VUE_APP_GOOGLE_MSP_KEY,
        version: 'weekly',
        language: SappModule.language || 'en', // 将 'ar' 改为 'en' 或 'zh-CN' 或 'zh-TW' 以更改语言
        mapId: '1ea87b22125a4812' // Map ID is required for advanced markers.
      })

      loader.load().then(async() => {
        const { Map } = await google.maps.importLibrary('maps')
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
          'marker',
        )
        this.map = new Map(document.getElementById('driverMapId'), {
          center: process.env.NODE_ENV.indexOf('holl') > -1 ? { lat: 51.5074, lng: 0.1278 } : { lat: 24.7136, lng: 46.6753 },
          zoom: 10,
          minZoom: 3, // 设置最小缩放级别
          disableDefaultUI: true,
          zoomControl: true,
          scaleControl: true,
          mapId: '1ea87b22125a4812' // Map ID is required for advanced markers.
        })
        this.mapDrawend = true
        if (this.pointArr && this.pointArr.length) {
          this.addDriver()
        }
        if (this.flightPath) {
          console.log(this.$t('vehicleTrajectory.index.890369-4'))
          this.flightPath.setMap(null)
          this.flightPath = null
        }
        if (this.latlngArr && this.latlngArr.length) {
          setTimeout(() => {
            this.addDriverLine()
          }, 0)
        }
      })
    },
    removeAllMarkers() {
      this.markerArr.forEach((marker) => {
        marker.setMap(null)
      })
      this.markerArr = []
    },
    showAllPoint(latlngArr) {
      const bounds = new google.maps.LatLngBounds()
      latlngArr.forEach(latlng => {
        bounds.extend(latlng)
      })
      this.map.fitBounds(bounds)
    },
    async addDriverLine() {
      if (this.flightPath) {
        this.flightPath.setMap(null)
        this.flightPath = null
      }
      setTimeout(async() => {
        this.showAllPoint([...this.latlngArr, ...this.pointArr.filter(e => e.lat && e.lng)])
        const latlngArrCopy = [...this.latlngArr]
        console.log('latlngArrCopy', latlngArrCopy)
        this.flightPath = new google.maps.Polyline({
          path: latlngArrCopy,
          geodesic: true,
          strokeColor: '#3D6FF0',
          strokeOpacity: 1.0,
          strokeWeight: 7
        })
        this.flightPath.setMap(this.map)
        if (this.formData.status === 140) {
          return
        }
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
          'marker',
        )
        const div = document.createElement('div')
        const div2 = document.createElement('div')
        div2.className = 'dirver-inner'
        div.appendChild(div2)
        let angle = 0
        let a = null
        let b = null
        try {
          a = latlngArrCopy[latlngArrCopy.length - 1] // 点 a 的经纬度
          b = this.pointArr[this.pointArr.length - 1] // 点 b 的经纬度

          angle = this.calculateAngle(a.lat, a.lng, b.lat, b.lng)
        } catch (error) {

        }
        // 示例经纬度 TODO

        div.className = 'custom-marker-driver-car'
        // 设置旋转角度，使车头指向 b 点
        div2.style.transform = `rotate(${angle + 70}deg)`
        div.setAttribute('data-index', 'car')
        div.style.width = '80px'
        div.style.height = '80px'
        div.style.display = 'flex'
        div.style.justifyContent = 'center'
        div.style.alignItems = 'center'
        div.style.transform = 'translate(0%, 50%)' // 使中心点对齐到经纬度位置
        const pinSvgMarkerView = new AdvancedMarkerElement({
          map: this.map,
          position: a,
          content: div,
          title: '',
          zIndex: 0
        })
        this.markerArr.push(pinSvgMarkerView)
      }, 2000)
    },
    async addDriver() {
      const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
        'marker',
      )
      this.showAllPoint([...this.latlngArr, ...this.pointArr.filter(e => e.lat && e.lng)])
      this.removeAllMarkers()
      this.markerArr = []
      // 给每个节点都打点  起始末尾点不一样需要注意
      this.pointArr.forEach((node, i) => {
        if (!node.lat || !node.lng) {
          return
        }
        const div = document.createElement('div')
        if (i === 0) {
          div.className = 'custom-marker-driver driver-start'
        } else if (i === this.pointArr.length - 1) {
          div.className = 'custom-marker-driver driver-end'
          // TODO   此处  需要检测车辆是否在途  不在途不渲染红色车辆
        } else {
          // 在 div 中间添加一个数字 2
          const textNode = document.createTextNode(i + 1)
          div.appendChild(textNode)
          div.className = 'custom-marker-driver'
        }
        div.setAttribute('data-index', i)
        const pinSvgMarkerView = new AdvancedMarkerElement({
          map: this.map,
          position: node,
          content: div,
          title: '',
          zIndex: 0
        })
        this.markerArr.push(pinSvgMarkerView)
        // pinSvgMarkerView.addListener('click', this.markerListener)
      })
    },
    calculateAngle(lat1, lon1, lat2, lon2) {
      const toRadians = (deg) => deg * (Math.PI / 180)
      const toDegrees = (rad) => rad * (180 / Math.PI)

      const φ1 = toRadians(lat1)
      const φ2 = toRadians(lat2)
      const Δλ = toRadians(lon2 - lon1)

      const y = Math.sin(Δλ) * Math.cos(φ2)
      const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ)
      const θ = Math.atan2(y, x)

      return (toDegrees(θ) + 360) % 360 // 角度范围为 [0, 360)
    }
  }
}
